export const zendeskConstants = {
  GETTICKET_SUCCESS: 'GETTICKET_SUCCESS',
  SAVE_TICKET_FILTER: 'SAVE_TICKET_FILTER',
  GET_ZENDESK_ACCOUNT_SUCCESS: 'GET_ZENDESK_ACCOUNT_SUCCESS',
  ADD_ZENDESK_ACCOUNT_SUCCESS: 'ADD_ZENDESK_ACCOUNT_SUCCESS',
};
